import { render, staticRenderFns } from "./NpaInitiative.vue?vue&type=template&id=37c9bdf5&scoped=true"
import script from "./NpaInitiative.vue?vue&type=script&lang=js"
export * from "./NpaInitiative.vue?vue&type=script&lang=js"
import style0 from "./NpaInitiative.vue?vue&type=style&index=0&id=37c9bdf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c9bdf5",
  null
  
)

export default component.exports